import { ReactElement } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import AvatarCat from '@components/AvatarCat';

import DependantCounter from './DependantCounter';

interface DependantCounterI {
  count: number;
  setCount: (count: number) => void;
  max?: number;
}

const QuoteCard = ({ count, setCount }: DependantCounterI ): ReactElement => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="flex flex-1 items-center bg-[#1f61f7] p-4 rounded-t-lg">
        <p className="text-white text-base leading-6 font-bold">{t('quote_card.header.title')}</p>
      </div>
      <div className="flex flex-col border-solid border border-t-0 border-[##AFBACC] bg-[#f5f7fa] p-4 rounded-b-lg justify-between gap-4">
        <div className="flex flex-1 flex-row justify-between items-start bg-[#ebfbe2] p-4 gap-4">
          <AvatarCat width={200} height={200} />
          <div>
            <p className="text-color/neutral/80 font-normal">
              <Trans
                t={t}
                i18nKey="quote_card.body.info"
                components={{
                  span: <span className="font-semibold paragraph/s" />,
                }}
              />
            </p>
          </div>
        </div>
        <div className="flex flex-1 flex-col justify-between gap-4">
          <p className="text-color/neutral/80 text-sm leading-6 font-normal">
            {t('quote_card.body.peoples_in_your_trip')}
          </p>
          <div>
            <DependantCounter count={count} setCount={setCount} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuoteCard;
